// NATIVE

// INSTALLED
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';

// CUSTOM

/**
 * A functional component that renders a copyright notice.
 *
 * @param {any} props - The properties passed to the component.
 * @returns {JSX.Element} A Typography component containing the copyright notice.
 *
 * @example
 * <CopyRight />
 *
 * @remarks
 * This component uses Material-UI's Typography and Link components to display
 * a copyright notice with the current year and a link to the Qihotels website.
 */
export const CopyRight = (props: any) => {
  return (
    <Typography variant="body2" color="text.secondary" align="center" {...props}>
      {'Copyright © '}
      <Link target="_blank" color="inherit" href="#">
        Qihotels
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
};
